import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getBrandsList = () => {
  return axiosClient.get("/api/admin/brands/list").then((r) => r.data);
};
